import Cookies from 'cookies-js';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorPopup } from '../../actions/notification-actions';
import { wipeBrazeUser } from '../../utils/braze';
import { responseStatusTypes } from '../../utils/constants';
import { getApiAxiosInstance } from '../../utils/network';

export const useLogout = () => {
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const logoutEndpoint = '/v1/auth/logout';
    const jwtCookie = 'jwt';
    const loginPagePath = '/';

    const logoutUser = async () => {
        const { user } = auth || {};

        if (!user) {
            return;
        }

        try {
            const axiosInstance = getApiAxiosInstance();
            const res = await axiosInstance.get(logoutEndpoint);

            if (res.status !== responseStatusTypes.OK) {
                return;
            }

            try {
                window?.fcWidget?.destroy();
            } catch {
                // ignore errors destroying Freshchat widget
            }

            if (window?.analytics) {
                window.analytics.reset();
            }

            await wipeBrazeUser();

            Cookies.expire(jwtCookie);

            if (res?.data.federatedLogoutUrl) {
                window.location.href = res.data.federatedLogoutUrl;
            } else {
                window.location.href = loginPagePath;
            }
        } catch (error) {
            dispatch(showErrorPopup({ message: 'An error occurred during logout', error }));
        }
    };

    return { logoutUser };
};
